import { css } from "@emotion/core";

export const CAT_WORKPLAN_SPINNER_CSS_OVERRIDE = css`
  background: rgba(0, 0, 0, 0);
  z-index: 1000;
  /* background: linear-gradient(to left, #00c6ff, #0072ff); */
  font-family: arial;
  width: 110%;
  height: 110%;
  position: fixed;
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-position: center;
  padding-top: 17%;
  padding-left: 29%;
`;
